import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  percentageComplete: number;
}

const useStyles = makeStyles<Props>({
  name: 'MuiInteractiveQuoteFormProgressBar',
})(({ brandColors, breakpoints, typography }, props) => ({
  container: {
    marginBottom: typography.pxToRem(68),
    width: typography.pxToRem(458),
    [breakpoints.down(ScreenSize.LARGE)]: {
      marginBottom: typography.pxToRem(43),
    },
    [breakpoints.down(ScreenSize.MEDIUM)]: {
      marginBottom: typography.pxToRem(43),
      width: '100%',
    },
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: typography.pxToRem(13),
    width: `${props.percentageComplete}%`,
  },
  percentageCompleteBar: {
    height: 8,
    backgroundColor: brandColors.heroBlue,
    width: `${props.percentageComplete}%`,
  },
  totalBar: {
    height: 1,
    backgroundColor: brandColors.heroBlue,
    width: '100%',
  },
}));

export default useStyles;
